export type ImageLike = {
  imageType?: string | null;
  imageName?: string | null;
  imageUrl?: string | null;
};

export type ImageFallbackOrder = ReadonlyArray<string>;

type SelectPreferredImageOptions = {
  fallbackToFirstWithUrl?: boolean;
};

export const SERIES_CARD_IMAGE_ORDER = ["Feature", "Thumbnail", "Hero"] as const;
export const SERIES_PROMPT_IMAGE_ORDER = ["Hero"] as const;
export const SERIES_THUMBNAIL_IMAGE_ORDER = ["Thumbnail", "Hero", "Feature"] as const;
export const RELATED_SERIES_IMAGE_ORDER = ["Thumbnail", "Feature", "Video Series Poster", "Poster"] as const;
export const MEDIA_SESSION_SERIES_IMAGE_ORDER = ["Lock Screen", "Thumbnail"] as const;

function hasImageUrl<T extends ImageLike>(image: T | null | undefined): image is T {
  return typeof image?.imageUrl === "string" && image.imageUrl.length > 0;
}

export function selectPreferredImage<T extends ImageLike>(
  images: ReadonlyArray<T | null | undefined> | null | undefined,
  order: ImageFallbackOrder,
  options?: SelectPreferredImageOptions,
): T | null {
  const availableImages = images?.filter(hasImageUrl) ?? [];

  if (availableImages.length === 0) {
    return null;
  }

  for (const imageType of order) {
    const matchingImage = availableImages.find((image) => image.imageType === imageType);
    if (matchingImage) {
      return matchingImage;
    }
  }

  if (options?.fallbackToFirstWithUrl === false) {
    return null;
  }

  return availableImages[0] ?? null;
}

export function selectPreferredImageUrl<T extends ImageLike>(
  images: ReadonlyArray<T | null | undefined> | null | undefined,
  order: ImageFallbackOrder,
  options?: SelectPreferredImageOptions,
): string | null {
  return selectPreferredImage(images, order, options)?.imageUrl ?? null;
}
